import type { IInitCartStore } from "../types/api/cart";
import { CurrencyCode } from "../types/generated/storefront.types";

/** cart 스토어 공통 초기 데이터 */
export const initCart: IInitCartStore = {
  cart: {
    appliedGiftCards: [],
    delivery: { addresses: [] },
    discountApplications: [],
    attributes: [],
    deliveryGroups: {
      edges: [],
      nodes: [],
      pageInfo: {
        hasNextPage: false,
        hasPreviousPage: false,
      },
    },
    estimatedCost: {
      checkoutChargeAmount: {
        amount: "",
        currencyCode: CurrencyCode.Krw,
      },
      subtotalAmount: {
        amount: "",
        currencyCode: CurrencyCode.Krw,
      },
      totalAmount: {
        amount: "",
        currencyCode: CurrencyCode.Krw,
      },
    },
    checkoutUrl: "",
    createdAt: "",
    metafields: [],
    updatedAt: "",
    buyerIdentity: {
      deliveryAddressPreferences: [],
    },
    cost: {
      checkoutChargeAmount: {
        amount: "",
        currencyCode: CurrencyCode.Krw,
      },
      subtotalAmount: {
        amount: "",
        currencyCode: CurrencyCode.Krw,
      },
      totalAmount: {
        amount: "",
        currencyCode: CurrencyCode.Krw,
      },
      __typename: "CartCost",
      subtotalAmountEstimated: false,
      totalAmountEstimated: false,
      totalDutyAmountEstimated: false,
      totalTaxAmountEstimated: false,
    },
    discountAllocations: [],
    discountCodes: [],
    id: "",
    lines: {
      edges: [],
      nodes: [],
      pageInfo: {
        endCursor: undefined,
        hasNextPage: false,
        hasPreviousPage: false,
        startCursor: undefined,
      },
    },
    totalQuantity: 0,
  },
};
